import Vue from 'vue';
import { Module } from 'vuex';

import { RootState, UserContentBundle } from 'frontend/types';
import { getJson } from 'frontend/utils/ajax';

const downloadUserContentBundle: Module<UserContentBundle, RootState> = {
  namespaced: true,
  state: {} as UserContentBundle,
  mutations: {
    setValue(state: UserContentBundle, value: UserContentBundle) {
      Object.entries(value).forEach(([k, v]) => {
        Vue.set(state, k, v);
      });
    },
  },
  actions: {
    startUserContentBundle({ commit, state, dispatch }) {
      getJson('/account/settings/data-portal/start-user-content-bundle/').then(response => {
        commit('setValue', response.results.bundle);
        setTimeout(() => dispatch('checkUserContentBundle', 0), 1000);
      });
    },
    checkUserContentBundle({ commit, state, dispatch }, count) {
      getJson(
        `/account/settings/data-portal/check-user-content-bundle/?bundle_id=${state.bundle_id}`,
      ).then(response => {
        commit('setValue', response.results.bundle);
        if (state.state !== 'ready' && state.state !== 'failed') {
          // slowly back off interval. (e.g., poll every 8 seconds after total 10 minutes)
          setTimeout(() => dispatch('checkUserContentBundle', count + 1), 1000 + count * 50);
        }
      });
    },
  },
};

export default downloadUserContentBundle;
